import { render, staticRenderFns } from "./homeDepositar.vue?vue&type=template&id=b05a5228"
import script from "./homeDepositar.vue?vue&type=script&lang=ts"
export * from "./homeDepositar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports